module.exports = __webpack_public_path__ + "static/media/grid.a52065de.svg";